<template>
    <div id="app">
        <notifications position="top center" width="30%" group="general"></notifications>
        <notifications position="top right" group="misc"></notifications>
        <component :is="layout">
            <router-view></router-view>
        </component>
    </div>
</template>

<script>
import Price from '@/services/hatsApi/Price'
import Gender from '@/services/hatsApi/Gender'
import Geo from '@/services/hatsApi/Geo'
import Language from '@/services/hatsApi/Language'
import axios from 'axios'
const DEFAULT_LAYOUT = 'default'

export default {
  computed: {
    layout () {
      return (this.$route.meta.layout || DEFAULT_LAYOUT) + '-layout'
    },
    isLoggedIn () {
      return this.$store.getters.isLoggedIn
    }
  },
  mounted () {
    if (this.isOffline) {
      alert('You are offline! The website will not work')
    }
  },
  async created () {
    axios.interceptors.response.use(
      function (response) { return response },
      function (error) {
        // handle error
        if (error.response) {
          alert(error.response.data.message)
        }
      }
    )
    this.getDependencies()
    this.debouncedNotification = this.$_.debounce(this.getErrors, 1000)
  },
  methods: {
    getErrors (val) {
      let errors = []
      val.items.forEach(error => errors.push('<li>' + error.field + ': ' + error.msg + '</li>'))
      let msg = '<ul>' + errors.join('') + '</ul>'
      if (val.items.length) {
        this.$notify({
          group: 'general',
          title: 'Invalid',
          type: 'error',
          text: msg,
          ignoreDuplicates: true
        })
      }
    },
    async getDependencies () {
      if (!this.$store.getters.calcTypes.length && this.isLoggedIn) {
        try {
          let calcTypeResponse = await Price.getPriceRuleCalcTypes()
          this.$store.commit('calcTypes', calcTypeResponse.data.data)
        } catch (e) {
          console.error(e)
        }
      }
      if (!this.$store.getters.priceRuleTypes.length && this.isLoggedIn) {
        try {
          let priceRuleTypeResponse = await Price.getPriceRuleTypes()
          this.$store.commit('priceRuleTypes', priceRuleTypeResponse.data.data)
        } catch (e) {
          console.error(e)
        }
      }
      if (!this.$store.getters.genders.length && this.isLoggedIn) {
        try {
          const genderResponse = await Gender.getGenders()
          let genders = genderResponse.data.data
          genders.unshift({id: '0', name_EN: 'n/a', name_NL: 'nvt', name_DE: 'n/a', code: ''})
          this.$store.commit('genders', genders)
        } catch (e) {
          console.error(e)
        }
      }
      if (!this.$store.getters.countries.length && this.isLoggedIn) {
        try {
          const countryResponse = await Geo.getCountries()
          let countries = countryResponse.data.data
          countries.unshift({id: '0', name_NL: 'Land', code: ''})
          this.$store.commit('countries', countries)
        } catch (e) {
          console.error(e)
        }
      }
      if (!this.$store.getters.languages.length && this.isLoggedIn) {
        try {
          const languageResponse = await Language.getLanguages()
          let languages = languageResponse.data.data
          this.$store.commit('languages', languages)
        } catch (e) {
          console.error(e)
        }
      }
    }
  },
  watch: {
    errors: {
      handler (val) {
        this.debouncedNotification(val)
      },
      deep: true
    },
    isLoggedIn (val) {
      if (val === true) {
        this.getDependencies()
      }
    }
  }
}
</script>

<style>
    #app {
        overflow-x: hidden;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue